<app-header
  [loginUrl]="env.redirectUrl"
  [showLanguageToggler]="features.isOff('yt-19374-pace-pause-prequal-updates')"
  (languageChange)="toggleLanguage($event)"
  [currentLanguage]="preferredLanguage$ | async"
>
</app-header>
